import "jquery-form";
import "jquery-validation";
import "../validator-rules"
import ssoTool from "../tools/sso.tool";
import ssoAlert from "../tools/sso.alert";
import ssoAjax from "../tools/sso.ajax";

export function init() {
    const passwordResetForm = $('#password_reset_form');
    const btnSubmit = $('#btn_submit');

    ssoTool.setInputEyeSwitch('#password');
    ssoTool.setInputEyeSwitch('#password_confirm');

    passwordResetForm.validate({
        showErrors: function() {
            if (this.numberOfInvalids() > 0) {
                btnSubmit.addClass('disabled');
            } else {
                btnSubmit.removeClass('disabled');
            }

            this.defaultShowErrors();
        },
        errorElement: 'span',
        errorPlacement: function(error, element) {
            element.closest('.col').find('div.error-message').html(error);
        },
        submitHandler: function(form) {
            ssoAjax.submit(form, function(response) {
                try {
                    if (response.status === false) {
                        throw new Error(response.message);
                    }

                    ssoAlert.success(language.password_reset, {
                        footer: `<a href="${loginUrl}" class="btn btn-primary text-white w-100 fw-bold">${globalLanguage.ok}</a>`,
                    });

                    $(form).resetForm();
                } catch (e) {
                    ssoAlert.error(e.message);
                }

                ssoAjax.btnSetToSubmit();
            })
        }
    });

}
